import React, {FC, useMemo} from 'react';

import {ITableActionProps} from 'components/table/action';
import {ButtonActionForDeleteRows} from 'components/table/action/button-action-delete-rows';
import {STATUS_CODES} from 'components/table/columns/factor-influence-status-cell/factor-influence-status-cell.consts';
import {selectTableEntityData} from 'modules/data/data-selectors';
import {useAppSelector} from 'store/config/hooks';

interface IFactorInfluenceInfoDeleteRowsModalOpenerProps extends ITableActionProps {}

export const FactorInfluenceInfoDeleteRowsModalOpener: FC<IFactorInfluenceInfoDeleteRowsModalOpenerProps> = ({
    wrapper,
    meta,
    entityName,
    ...props
}: IFactorInfluenceInfoDeleteRowsModalOpenerProps) => {
    const tableData = useAppSelector(selectTableEntityData(entityName || ''));
    const selectedRows = useMemo(() => tableData?.selectedRows || [], [tableData?.selectedRows]);

    const isButtonDisabled = useMemo(
        () => selectedRows.some((row) => row?.statusText !== STATUS_CODES.DRAFT),
        [selectedRows]
    );

    return (
        <ButtonActionForDeleteRows
            wrapper={wrapper}
            meta={meta}
            entityName={entityName}
            isDisabled={isButtonDisabled}
            {...props}
        />
    );
};
